import InvestmentHandler from './InvestmentHandler';

export default InvestmentHandler;
